
import { defineComponent, reactive, ref } from 'vue'
import QForm from 'quasar/src/components/form/QForm.js';
import { EmployeeRouteNames } from '@/router/routes-names'
import { useSessionModule, ChangePasswordRequest } from '@/modules/session'
import { useFormModule } from '@/modules/_shared/forms'
import SessionFormFieldPassword from '@/components/session/form-fields/password.vue'
import SessionFormFieldRepeatPassword from '@/components/session/form-fields/repeat-password.vue'

export default defineComponent({
    name: 'session-change-password-form',
    components: { SessionFormFieldRepeatPassword, SessionFormFieldPassword },
    setup () {
        const { changePassword } = useSessionModule()
        const { submitForm, createOnSuccess } = useFormModule()
        const form = ref<QForm>()
        const employeeModel = reactive<Partial<ChangePasswordRequest & {repeatPassword: string}>>({
            oldPassword: undefined,
            newPassword: undefined,
            repeatPassword: undefined
        })

        const sendForm = async () => changePassword({
            oldPassword: employeeModel.oldPassword as string,
            newPassword: employeeModel.newPassword as string
        })

        const onSubmit = () => submitForm(
            form.value,
            sendForm,
            createOnSuccess('Your password has changed')
        )

        return {
            onSubmit,
            employeeModel,
            form,
            routesNames: EmployeeRouteNames
        }
    }
})
